import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

export interface IConfirmModalProps {
  handleClose: () => void;
  handleConfirm: () => void;
  show: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  dismissLabel: string;
  isLoading?: boolean;
}

const ConfirmModal: React.FunctionComponent<IConfirmModalProps> = ({
  handleClose,
  handleConfirm,
  show,
  title,
  message,
  confirmLabel,
  dismissLabel,
  isLoading,
}) => {
  return (
    <Dialog open={show} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>{message}</DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="error" variant="outlined" disabled={isLoading}>
          {dismissLabel}
        </Button>

        <Button onClick={handleConfirm} variant="contained" loading={isLoading}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
